import React from "react";

const About = () => {
  return (
    <section
      id="about"
      style={{
        padding: "4rem 1.5rem",
        backgroundColor: "#f9fafb",
      }}
    >
      <div
        style={{
          maxWidth: "900px",
          margin: "0 auto",
          background: "#fff",
          borderRadius: "12px",
          padding: "2.5rem",
          boxShadow: "0 4px 15px rgba(0,0,0,0.08)",
        }}
      >
        <h2
          style={{
            fontSize: "2rem",
            fontWeight: "600",
            marginBottom: "1rem",
            color: "#222",
            textAlign: "center",
          }}
        >
          About This Property
        </h2>

        <p
          style={{
            fontSize: "1.05rem",
            lineHeight: "1.7",
            color: "#555",
            marginBottom: "1.5rem",
            textAlign: "center",
          }}
        >
          Discover luxury living at <strong>10 Roosevelt Rd</strong>, a stunning townhouse in the heart of Maplewood, NJ.
          This exquisite property features modern design, high-end finishes, and spacious interiors perfect for contemporary living.
        </p>

        <p
          style={{
            fontSize: "1.05rem",
            lineHeight: "1.7",
            color: "#555",
            marginBottom: "2rem",
            textAlign: "center",
          }}
        >
          Enjoy the perfect blend of elegance and comfort in this prime location.
        </p>

        <h3
          style={{
            fontSize: "1.3rem",
            marginBottom: "1rem",
            color: "#333",
            textAlign: "center",
          }}
        >
          Key Features
        </h3>

        <ul
          style={{
            listStyle: "none",
            padding: 0,
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
            gap: "1rem",
          }}
        >
          {[
            "Spacious open floor plan",
            "Premium appliances and fixtures",
            "Private outdoor space",
            "Close to local amenities and transportation",
          ].map((item, index) => (
            <li
              key={index}
              style={{
                background: "#f1f5f9",
                padding: "0.9rem 1rem",
                borderRadius: "8px",
                fontSize: "0.95rem",
                color: "#444",
                display: "flex",
                alignItems: "center",
                gap: "0.5rem",
              }}
            >
              <span style={{ color: "#16a34a", fontWeight: "bold" }}>✔</span>
              {item}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default About;